export const iconFontAwesomeMapsMonument = (
	<i className="fa-solid fa-monument"></i>
);
